import { useSearchInstallment } from "../../../hooks/fetch-data/useSearchInstallment";
import { getLoanList } from "../../../utils/loan";

export function useLoanInfo({ loanId, userData }) {
  const {
    data: userLoanInfo,
    refetch,
    isFetching,
  } = useSearchInstallment(userData?.id);

  const loans = getLoanList(userLoanInfo);

  const loanInfo = loans?.find((loan) => loan.loan_id === parseInt(loanId));

  return { loanInfo, refetch, isFetching };
}
